import React, { createContext, useState, useMemo, useEffect } from 'react';

export const NotifiContext = createContext(null);

export const CartProvider = ({ children }) => {
	const [key, setKey] = useState(0);
	const [notiCount, setNotiCount] = useState(0);
	const [notiList, setNotiList] = useState([]);

	useEffect(() => {
		const ldata = localStorage.getItem('sdcart_NotifiContext');

		if (ldata !== null) {
			try {
				const data = JSON.parse(ldata);
				if (data && typeof data.key !== 'undefined') setKey(data.key);
			} catch (e) {
				// ignore invalid json
			}
		}
	}, []);

	useEffect(() => {
		// Persist the key to localStorage whenever it changes
		const data = { key };
		try {
			localStorage.setItem('sdcart_NotifiContext', JSON.stringify(data));
		} catch (e) {
			// ignore storage failures
		}
	}, [key]);

	const values = useMemo(
		() => ({
			notiCount,
			setNotiCount,
			notiList,
			setNotiList,
			key,
			setKey,
		}),
		[key, notiCount, notiList],
	);

	return <NotifiContext.Provider value={values}>{children}</NotifiContext.Provider>;
};
